import { UAApps } from '@unifyapps/defs/types/apps';
import type { AutomationInputsType, NodeContextType } from '@unifyapps/defs/types/dataSource';
import { useMemo } from 'react';
import { useClientContext } from '../../../../../../context/client';
import {
  CLIENT_KEY,
  CLIENT_TYPE_KEY,
  INTERNALS_PARAMETERS_KEY,
  PAGE_SLUG_KEY,
  PLATFORM_KEY,
} from '../../../../../const';
import { getDevice } from '../../../../../utils/getDevice';
import { useDSCActivePageSlug, useDSCMode } from '../../../context/selectors';

export function useAddSystemParameters({
  inputs,
  context,
}: {
  inputs: AutomationInputsType;
  context?: NodeContextType;
}) {
  const mode = useDSCMode();
  const activePageSlug = useDSCActivePageSlug();
  const { client } = useClientContext() ?? {};
  const device = useMemo(() => getDevice(), []);

  return useMemo(() => {
    if (context?.appName === UAApps.Callables) {
      return {
        ...inputs,
        parameters: {
          ...inputs.parameters,
          [INTERNALS_PARAMETERS_KEY]: {
            [CLIENT_KEY]: mode,
            [PAGE_SLUG_KEY]: activePageSlug,
            [CLIENT_TYPE_KEY]: client,
            [PLATFORM_KEY]: device,
          },
        },
      };
    }
    return inputs;
  }, [inputs, context?.appName, mode, client, device, activePageSlug]);
}
